import React from "react";

import {
    TwitterX,
    FacebookCircle,
    InstagramFilled,
    LinkedinFilled,
    YoutubeFilled,
    TikTokV2,
    WhatsApp,
    Tripadvisor,
    SocialMediaIconVariant,
} from "src/components/icon/iconset";

import Link from "src/components/link";

type SocialMediaProps = {
    className?: string;
    items: Array<TFooterSocialMediaItem>;
    iconStyle?: SocialMediaIconVariant;
}

export default class SocialMedia extends React.Component<SocialMediaProps> {
    static defaultProps: Partial<SocialMediaProps> = {
        className: "",
        iconStyle: "original"
    }

    renderItem(item: TFooterSocialMediaItem, index: number) {
        switch (item.footer_social_media_item_id?.social_media_type) {
            case "x": 
                return <Link key={"linktwi"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="Twitter">
                    <TwitterX className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "facebook": 
                return <Link key={"linkfac"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="Facebook">
                    <FacebookCircle className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "instagram": 
                return <Link key={"linkins"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="Instagram">
                    <InstagramFilled className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "linkedin": 
                return <Link key={"linklin"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="LinkedIn">
                    <LinkedinFilled className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "youtube": 
                return <Link key={"linkyou"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="YouTube">
                    <YoutubeFilled className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "tiktok": 
                return <Link key={"linktik"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="TikTok">
                    <TikTokV2 className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "tripadvisor": 
                return <Link key={"linktri"+index} href={item.footer_social_media_item_id.link} className="text-[color:var(--social-media-icons-color)]" title="Tripadvisor">
                    <Tripadvisor className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            case "whatsapp": 
                return <Link key={"linkwpp"+index} href={`https://wa.me/${item.footer_social_media_item_id.link}`} className="text-[color:var(--social-media-icons-color)]" title="WhatsApp">
                    <WhatsApp className={"w-6 h-6"} variant={this.props.iconStyle} />
                </Link>
            default: 
                return null;
        }
    }

    render() {
        return <div className={`flex flex-row gap-6 ${this.props.className}`}>
            {
                this.props.items
                .sort((a, b) => a.position - b.position)
                .map((item, index) => this.renderItem(item, index))
            }
        </div>
    }
}
